<template>
  <div>

  </div>
</template>

<script>
import store from '../store/store'
import {ebus} from '@/vendor/ebus';
import * as util from '../vendor/util'
import {clearEvents, clearTheInterval, insertQueryParam} from '../vendor/util'
import * as qconst from '../vendor/qconstants';
import {alwaysAskForTableNumberInhouse} from '../vendor/qconstants';
import * as appManager from '@/vendor/appManager'
import {getGlobalValue, removeGlobalKey, setGlobalKeyValue} from "@/util/globalState";
import {parseTableOrNull} from "@/vendor/util";

// import {getStoreScannedError} from "@/util/itemAvailabilityChecker";

export default {
  data: () => ({
    iv1: null,
    expire: 2 * 60 * 60 * 1000,//expiry 2 hours,
    forceTakeaway: false,
  }),
  created() {

    ebus.$on('appconfigLoaded', () => {
      this.lazySuggestQrCodeScan();
    });
    ebus.$on('forceInhouseModus', (p) => {
      this.forceInhouseModus(p.table, p.filialnummer);
    });
    ebus.$on('updateInhouseModus', () => {
      this.updateTableAndInhouseModus();
    });
    ebus.$on('clearInhouseModus', (params) => {
      this.clearInhouseModus(params);
    });
    ebus.$on('userEnteredTable', (table) => {
      this.userEnteredTable(table);
    });
  },
  destroyed() {
    this.duringInit = false;
    clearEvents([
      'appconfigLoaded',
      'forceInhouseModus',
      'updateInhouseModus',
      'clearInhouseModus',
      'userEnteredTable',
    ]);
    clearTheInterval(this.iv1);
  },
  beforeMount() {
    setGlobalKeyValue('handleQuery', true);
    setTimeout(() => {
      removeGlobalKey('handleQuery');
    }, 10 * 1000);
    // this.repairQuery();
    this.handleQuery();
    this.repairQuery();
    // this.updateTableAndInhouseModus();
    this.initIv()
    setTimeout(() => {
      this.repairQuery();
    }, 2000);
  },
  mounted() {
    // appconfigLoaded
    this.lazySuggestQrCodeScan();
  },
  methods: {
    lazySuggestQrCodeScan() {
      //suggestQrCodeScan of only inhouse is enabled and there is no valid table
      if (!store.getters.isKiosk && !store.state.enableOrderModeSelectionWithTime
        && (!store.getters.table || store.getters.table === store.state.defaultInhouseTable)) {
        if (!store.getters.enableTakeawayPay && !store.getters.enableTakeawayOhnePay && !store.getters.enableDeliveryPay && !store.getters.enableDeliveryOhnePay) {
          if (store.getters.enableInhousePay || store.getters.enableInhouseOhnePay) {
            ebus.$emit('suggestQrCodeScan');
          }
        }
      }
    },

    repairQuery() {

      let kioskTable = this.$ls.get('kioskTable');
      if (kioskTable) {
        insertQueryParam('kiosk', kioskTable);
      }

      let scannedTable = parseTableOrNull(this.$ls.get('scannedTable'));
      if (!kioskTable && scannedTable) {
        util.insertQueryParam('table', '' + scannedTable);
      }
      // OnlyforFilialbetriebe
      // let scannedStore = this.$ls.get('scannedStore');
      // if (scannedStore) {
      //   util.insertQueryParam('store', scannedStore);
      // }
    },
    checkStoreScanned(cb) {
      cb();
      // OnlyforFilialbetriebe
      // try {
      //   console.log('checkStoreScanned')
      //   if (!this.$ls.get('scannedTable')) {
      //     return;
      //   }
      //   let allStores = util.cloneMe(store.getters.stores);
      //   let myFilialnummer = store.getters.inhouseStoreFilialnummer ? '' + store.getters.inhouseStoreFilialnummer : '';
      //   if (!myFilialnummer || !allStores?.length) {
      //     //retry
      //     setTimeout(() => {
      //       this.checkStoreScanned(cb)
      //     }, 1000);
      //     return;
      //   }
      //   let myStore = allStores.find(s => s.filialnummer === myFilialnummer);
      //   if (!myStore) {
      //     // if (!silent) {
      //     //   ebus.$emit('showInfo', {
      //     //     title: 'Aktuelle Filiale ungültig. Bitte den QR-Code  am Tisch erneut einscannen, um bestellen zu können.',
      //     //     text: 'Die Artikel im Korb bleiben hierbei erhalten.'
      //     //   });
      //     // }
      //     this.clearInhouseModus('checkStoreScanned');
      //
      //     return;
      //   }
      //
      //   //prüfe öffnungszeit
      //   let storeScannedError = getStoreScannedError(myStore);
      //   if (storeScannedError) {
      //     ebus.$emit('showInfo', {
      //       title: storeScannedError,
      //       text: ''
      //     });
      //     this.clearInhouseModus('Öffnungszeit');
      //     // ebus.$emit('toast', 'Der Takeaway Modus ist jetzt aktiviert',);
      //     this.$router.push({name: 'Home'});
      //     return;
      //   }
      //
      //   cb();
      //
      // } catch (e) {
      //   console.log('Error in prüfe öffnungszeit: ' + e.message);
      //   cb();
      // }
    },

    // lazyUpdateEnteredAtFirstTime() {
    //   let inhouseEnteredAt = this.$ls.get('inhouseEnteredAt') || -1;
    //   if (inhouseEnteredAt === -1) {
    //     this.$ls.set('inhouseEnteredAt', Date.now(), 4 * 60 * 60 * 1000);
    //     return true; //true = first time
    //   }
    //   return false;//false = not first time
    // },

    forceInhouseModus(_table, filialnummer) {
      console.log('forceInhouseModus ' + _table);
      if (!_table) {
        return;
      }
      setGlobalKeyValue('handleQuery', true);
      setTimeout(() => {
        removeGlobalKey('handleQuery');
      }, 10 * 1000);
      let table = parseTableOrNull(_table);
      this.forceTakeaway = false;
      store.commit('selectedPickupTime', false);
      let exp = this.expire;
      this.$ls.set('scannedTable', table, exp);
      // OnlyforFilialbetriebe
      // this.$ls.set('scannedStore', filialnummer, exp);
      this.$store.commit('table', table);
      this.$store.commit('inhouse', true);
      setGlobalKeyValue('notifyTableAfterValidations', true);
      this.repairQuery();
      removeGlobalKey('handleQuery')
      this.updateTableAndInhouseModus(true);
      // ebus.$emit('toast', 'Der Inhouse Modus ist jetzt aktiviert');
      setTimeout(() => {
        this.lazyJumpToSotiment();
      }, 400);
      console.log('forceInhouseModus switched to Sortiment');
    },
    initIv() {
      if (this.iv1) {
        util.clearTheInterval(this.iv1);
      }
      this.iv1 = setInterval(() => {
        this.updateTableAndInhouseModus();
      }, 8 * 1000);
    },
    insertInhouseReferenceToUrl() {
      let query = window.location.search;
      let params = new URLSearchParams(query);
      let table = params.get('table');
      let kioskTable = params.get('kiosk');
      if (kioskTable) {
        table = kioskTable;
      }
      if (table) {
        let t = parseTableOrNull(table);
        if (t) {
          let sTable = '' + t;
          util.insertQueryParam((kioskTable ? 'kiosk' : 'table'), sTable);
        } else {
          return false;
        }
      } else {
        return false;
      }

      // OnlyforFilialbetriebe
      // let storeNumber = params.get('store');
      // let sFilialnummer = '' + store.getters.inhouseStoreFilialnummer
      // if (!storeNumber && sFilialnummer) {
      //   util.insertQueryParam('store', sFilialnummer);
      // }
      if (getGlobalValue('notifyTableAfterValidations')) {
        removeGlobalKey('notifyTableAfterValidations');
        if (!kioskTable && table !== ('' + store.state.defaultInhouseTable)) {
          if (!alwaysAskForTableNumberInhouse) {
            ebus.$emit('showInfo', {
              title: 'Herzlich Willkommen bei ' + store.state.brandName,
              text: 'Du buchst jetzt auf Tisch ' + table,
            });
          }
        } else if (kioskTable) {
          // ebus.$emit('showInfo', {
          //   title: 'Herzlich Willkommen bei ' + store.state.brandName,
          //   text: 'Du kannst nun am Kiosk bestellen und bezahlen',
          // });
        }
      }

      return true;
    },
    updateStep2() {
      let scannedTable = this.$ls.get('scannedTable');
      // OnlyforFilialbetriebe
      // let scannedStore = this.$ls.get('scannedStore');
      // if (scannedTable && scannedStore) {
      if (scannedTable) {
        if (store.getters.table === 0 || !qconst.enableFlexCodes) {
          this.$store.commit('table', scannedTable);
        }
        // } else {
        // this.$store.commit('table', 0);
      }

      if (this.forceTakeaway) {
        store.commit('inhouse', false);
        this.clearInhouseModus({eventSource: 'force takeaway'});
      } else {
        let inhouse = appManager.isInhouse();
        store.commit('inhouse', inhouse);
        // if (inhouse) {
        //   store.commit('orderMode', 'Inhouse');
        //   if (store.getters.orderMode !== 'Inhouse') {
        //     store.commit('orderMode', 'Inhouse');
        //   }
        // } else {
        //   if (store.getters.orderMode === 'Inhouse') {
        //     store.commit('orderMode', 'Takeaway');
        //   }
        // }
      }

      if (store.getters.inhouse) {
        this.insertInhouseReferenceToUrl();
      }
    },
    updateTableAndInhouseModus(force) {
      if (getGlobalValue('handleQuery') && !force) {
        return
      }

      this.handleInhouseExpired();

      if (this.$ls.get('scannedTable')) {
        this.checkStoreScanned(validated => {
          if (!this.$ls.get('scannedTable')) {
            removeGlobalKey('notifyTableAfterValidations');
          }
          this.updateStep2();
        });
      } else {
        this.updateStep2();
      }
    },
    initTableFlex() {
      console.log('initTableFlex...');
      if (this.$store.getters.inhouse) {
        if (qconst.forceTableScan && qconst.enableFlexCodes) {
          //setze ls tableFlex=true mit dauer von 30 Minuten
          let exp = this.expire;
          this.$ls.set('tableFlex', true, exp);

          // ergänze query parameter tableFlex=now timestamp
          let hash = '' + window.location.hash; // #/Welcome
          let path = window.location.pathname;// /
          let newurl = window.location.host + path + '?tableFlex=' + Date.now() + hash;
          if (store.state.orderArea) {
            newurl = window.location.host + path + '?area=' + store.state.orderArea + hash;
          }
          newurl = newurl.replaceAll('//', '/');
          console.log('newurl = ' + newurl);
          window.history.replaceState('', document.title, 'https://' + newurl); // added this line to push the new url directly to url bar .
        }
      }
    },
    userEnteredTable(_table) {
      try {
        let table = parseTableOrNull(_table);
        if (!table) {
          return;
        }
        // let scannedTableAt = this.$ls.get('scannedTableAt');
        // if (scannedTableAt) {
        //     let diff = Date.now() - scannedTableAt;
        //     this.$ls.set('scannedTable', table, diff);
        //     store.commit('table', table);
        // }
        let exp = this.expire;
        this.$ls.set('scannedTable', table, exp);
        store.commit('table', table);
        this.forceTakeaway = false;
        this.repairQuery();
        this.updateTableAndInhouseModus();
      } catch (e) {

      }
    },
    clearInhouseModus(params) {
      // if (getGlobalValue('handleQuery')) {
      //   return;
      // }
      console.log('clear inhouse by ' + params.eventSource);
      // alert('clear inhouse by ' + eventSource);
      removeGlobalKey('notifyTableAfterValidations');
      this.$ls.remove('inhouseEnteredAt');
      this.$ls.remove('tableFlex');
      this.$ls.remove('scannedTable');
      this.$ls.remove('kioskTable');
      this.$ls.get('userSelectedTargetTime')

      if (params.eventSource !== 'OrderModeSwitcher') {
        store.commit('setSelectedOrderModeByUser', '');
      }

      // OnlyforFilialbetriebe
      // this.$ls.remove('scannedStore');
      this.$store.commit('table', 0);
      store.commit('inhouse', false);
      // if (params.usecase) {
      //   store.commit('selectedUsecase', params.usecase);
      // } else {
      //   store.commit('selectedUsecase', 'takeAway');
      // }
      // this.$store.commit('inhouseStoreFilialnummer', '');
      try {
        util.removeAllQueryParams();
      } catch (e) {

      }
      this.updateTableAndInhouseModus();
    },
    handleInhouseExpired() {
      if (store.getters.inhouse && !this.$ls.get('kioskTable') && !this.$ls.get('scannedTable') && !this.$ls.get('guestMode')
        && !qconst.enableFlexCodes
      ) {
        console.log('table expired. clearInhouseModus');
        ebus.$emit('clearInhouseModus', {eventSource: 'Sidebar'});
        ebus.$emit('showInfo', {
          title: 'Die maximale Zeit am Tisch ist überschritten. Bitte scanne den Tisch QR-Code erneut',
        });
        this.clearInhouseModus({eventSource: 'handleInhouseExpired'});
      }
      // let scannedTable = this.$ls.get('scannedTable');
      // if (scannedTable) {
      //   if (!this.lazyUpdateEnteredAtFirstTime()) {
      //     let inhouseEnteredAt = this.$ls.get('inhouseEnteredAt') || -1;
      //     if (Date.now() - inhouseEnteredAt > this.expire) {
      //       scannedTable = '';
      //       this.clearInhouseModus(' expired handler');
      //       ebus.$emit('showInfo', {
      //         title: 'Die maximale Zeit am Tisch ist überschritten. Bitte scanne den Tisch QR-Code erneut',
      //       });
      //     }
      //   }
      // }
    },
    lazyJumpToSotiment() {
      if (getGlobalValue('userSwitchedOrderMode')) {
        return;
      }
      if (this.$route.name !== 'Home') {
        this.$router.push({name: 'Home'});
      }
    },
    handleQuery() {
      if (appManager.isInhouse()) {
        store.commit('inhouse', true);
      }

      //checkout couponCode in the request query parameter
      let query = window.location.search;
      if (query) {
        try {
          let params = new URLSearchParams(query);

          let cartId = params.get('cartId');
          if (cartId) {
            store.commit('cartId', cartId);
            ebus.$emit('restoreCartFromServer', cartId);
          }

          // OnlyforFilialbetriebe
          // let queryStore = params.get('store');
          // if (queryStore) {
          //   setGlobalKeyValue('preselectStoreId', queryStore);
          //   this.$ls.set('scannedStore', queryStore, this.expire);
          //   let selectedStore = store.getters.stores.find(s => s.filialnummer === queryStore);
          //   if (selectedStore) {
          //     store.commit('selectedStore', selectedStore);
          //     this.$store.commit('inhouseStoreFilialnummer', queryStore);
          //     console.log('selectedStore updated by query');
          //     // } else {
          //     console.log('preselectStoreId prepared by query');
          //     // this.checkStoreScanned();
          //   }
          // }

          let area = params.get('area');
          if (area) {
            store.commit('orderArea', area);
          }

          let takeaway = params.get('takeaway');
          let webshop = params.get('webshop');
          let t = params.get('t');
          let guestMode = params.get('guestMode');
          if (guestMode) {
            this.$ls.remove('scannedTable');
            let exp = this.expire;//expiry 30 minutes
            this.$ls.set('guestMode', true, exp);
            this.updateTableAndInhouseModus();
            util.removeAllQueryParams();
          } else if (t || webshop || (takeaway && takeaway === 'true')) {
            store.commit('setSelectedOrderModeByUser', 'takeAway');
            this.clearInhouseModus({eventSource: 'handleQuery with takwaway parameter'});
            this.$ls.remove('guestMode');
            this.$ls.remove('kioskTable');
            // this.forceTakeaway = true;
          } else {
            let table = parseTableOrNull(params.get('table'));
            let kioskTable = parseTableOrNull(params.get('kiosk'));
            if (kioskTable) {
              store.commit('setIsKiosk', !!kioskTable);
              this.$ls.remove('scannedTable');
              table = kioskTable;
              this.$ls.set('kioskTable', kioskTable);
              console.log('kioskTable was set in handleQueryF to ' + kioskTable);
              store.commit('setEnableOrderModeSelection', true);
              store.commit('setEnableOrderModeSelectionWithTime', false);
            }

            if (!table && !params.get('tableFlex') && !this.$ls.get('scannedTable')) {
              util.removeAllQueryParams();
            }
            if (table) {
              store.commit('setSelectedOrderModeByUser', 'inhouse');
              this.$ls.remove('guestMode');
              let exp = this.expire;//expiry 30 minutes
              if (!kioskTable) {
                this.$ls.set('scannedTable', table, exp);
              }
              store.commit('table', table);

              // appManager.setTable(table);

              this.$ls.remove('tableFlex');

              this.lazyJumpToSotiment();
              setGlobalKeyValue('notifyTableAfterValidations', true);

              //remove the query parameter
              // util.removeAllQueryParams();
              this.updateTableAndInhouseModus(true);

            } else if (qconst.enableFlexCodes) {
              let tableFlex = params.get('tableFlex');
              if (!tableFlex) {
                this.initTableFlex();
              } else {
                console.log('newurl = empty');
              }
            }
          }

          // ebus.$emit('updateInhouseModus');


          // let ih = params.get('inhouse');
          // store.commit('inhouse', !!ih);
          // setTimeout(()=>{
          //     console.log('is inhouse = '+store.getters.inhouse);
          // },5000);

          // let bivtr = params.get('bivtr');
          // if (bivtr) {
          //     //inviter
          //     if (!bootstrap.hasAccount()) {
          //         console.log('set bivtr = ' + bivtr);
          //         this.$ls.set('bivtr', bivtr);
          //     }
          // }
          //
          // let cc = params.get('couponCode');
          // if (cc) {
          //     store.commit('scannedCode', cc);
          //     console.log('coupon: scannedCode stored');
          //     this.lazyAddScannedCode(cc);
          //     this.showScannedCouponWarning(true);
          // } else {
          //     this.setLastScannedCode();
          // }
          //
          // let referrer = params.get('referrer');
          // if (referrer && !bootstrap.hasAccount()) {
          //     let ruid = params.get('ruid');
          //     let rpId = params.get('rpId');
          //     let referrerName = params.get('referrerName');
          //     let amountForFriend = params.get('amountForFriend');
          //
          //     //the friend stores the invitation into the localStorage
          //     let invitation = {
          //         referrer: referrer,
          //         ruid, ruid,
          //         rpId: rpId,
          //         referrerName: referrerName,
          //         amountForFriend: amountForFriend
          //     };
          //     this.$ls.set('invitation', JSON.stringify(invitation));
          //     this.showInvitation();
          // }


        } catch (e) {
          console.log('Error parsing search params: ', e);
        }
        // } else {
        //     this.setLastScannedCode();
      } else if (qconst.enableFlexCodes) {
        this.initTableFlex();
      }
    },
  },
}
</script>

<style scoped>

</style>
